import React, { useEffect, useState } from "react";
import { getArrearList, getIncentiveList } from "../Services/PayrollService";

export const ArrearsAndIncentives = ({ hideAmount }) => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [arrearsList, setArrearsList] = useState([]);
  const [incentiveList, setIncentiveList] = useState([]);
  

  useEffect(() => {
    fetchArrearsList();
    fetchIncentivesList();
  }, []);

  async function fetchArrearsList() {
    const req = {
      ArrearId: 0,
      OrgId: userDetails.OrgId || 0,
      GUID: "",
      EmpId: userDetails.EmpId || 0,
      PageNumber: 1,
      PageSize: 25,
      Search: "",
      ArrearStatusId: "",
      ArrearTypeId: "",
      LoggedInEmpId: userDetails.EmpId || 0,
    };

    try {
      const response = await getArrearList(req);
      setArrearsList(response?.Data?.ArrearResponseDetails || []);
      console.log(response, "response-----------");
    } catch (error) {
      console.error("Error fetching arrears list:", error);
    }
  }

  async function fetchIncentivesList() {
   let params = {
          IncentiveId: 0,
          OrgId: userDetails?.OrgId,
          GUID: "",
          EmpId: userDetails?.EmpId,
          PageNumber: 1,
          PageSize: 25,
          Search: "",
          IncentiveStatusId: "",
          IncentiveTypeId: "",
          LoggedInEmpId: userDetails?.EmpId,
        };
        try {
          let res = await getIncentiveList(params);
         setIncentiveList(res?.Data?.IncentiveResponseDetails || []);
        } catch (error) {
          console.error("Error fetching incentive list:", error);
        }
      
  }

  const renderAmt = (value) => {
    return hideAmount ? "•••••" : `₹${value.toLocaleString("en-IN")}`;
  };

  return (
    <div className="tab-panel active" id="tab-arrears">
      <div className="g2" style={{ marginBottom: 0 }}>
        {/* Arrears */}
        <div className="sec-card" style={{ marginBottom: 0 }}>
          <div className="sec-card-head">
            <i className="fa-solid fa-rotate-left text-brand"></i>
            <h6>My Arrears</h6>
            <span
              style={{
                marginLeft: "auto",
                fontSize: "11px",
                color: "var(--text-muted)",
              }}
            >
              Read only
            </span>
          </div>

          <div className="sec-card-body p0">
            <table className="ro-tbl">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>For Month</th>
                  <th className="tr">Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {arrearsList.length > 0 ? (
                  arrearsList.map((r, i) => (
                    <tr key={i}>
                      <td>
                        <span
                          className="badge badge-account"
                          style={{ fontSize: "10.5px" }}
                        >
                          {r.ArrearTypeName}
                        </span>
                      </td>
                      <td
                        style={{ fontSize: "12px", color: "var(--text-muted)" }}
                      >
                        {r.ForMonth}
                      </td>
                      <td className="tr" style={{ fontWeight: 700 }}>
                        {renderAmt(r.Amount)}
                      </td>
                      <td>
                        <span
                          className={`badge badge-${r.ArrearStatusName?.toLowerCase()}`}
                          style={{ fontSize: "10.5px" }}
                        >
                          {r.ArrearStatusName}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="4"
                      style={{
                        padding: 20,
                        textAlign: "center",
                        color: "var(--text-muted)",
                        fontSize: "12.5px",
                      }}
                    >
                      <i
                        className="fa-solid fa-check-circle"
                        style={{ color: "var(--success)", marginRight: 6 }}
                      ></i>
                      No pending arrears
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Incentives */}
        <div className="sec-card" style={{ marginBottom: 0 }}>
          <div className="sec-card-head">
            <i className="fa-solid fa-trophy text-brand"></i>
            <h6>My Incentives & Bonuses</h6>
            <span
              style={{
                marginLeft: "auto",
                fontSize: "11px",
                color: "var(--text-muted)",
              }}
            >
              Read only
            </span>
          </div>

          <div className="sec-card-body p0">
            <table className="ro-tbl">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Description</th>
                  <th className="tr">Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {incentiveList.length > 0 ? (
                  incentiveList.map((v, i) => (
                    <tr key={i}>
                      <td>
                        <span
                          className="badge badge-active"
                          style={{ fontSize: "10.5px" }}
                        >
                          {v.IncentiveTypeName}
                        </span>
                      </td>
                      <td
                        style={{ fontSize: "12px", color: "var(--text-muted)" }}
                      >
                        {v.Description}
                      </td>
                      <td className="tr" style={{ fontWeight: 700 }}>
                        {renderAmt(v.Amount)}
                      </td>
                      <td>
                        <span
                          className={`badge badge-${v.IncentiveStatusName?.toLowerCase()}`}
                          style={{ fontSize: "10.5px" }}
                        >
                          {v.IncentiveStatusName}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="4"
                      style={{
                        padding: 20,
                        textAlign: "center",
                        color: "var(--text-muted)",
                        fontSize: "12.5px",
                      }}
                    >
                      <i
                        className="fa-solid fa-check-circle"
                        style={{ color: "var(--success)", marginRight: 6 }}
                      ></i>
                      No pending incentives
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArrearsAndIncentives;
